<template>
  <collapsible-section class="_pt0 _pb0">
    <template #headerText>
      <p>Invoice Overview</p>
    </template>
    <template #headerActions>
      <download-button
        @click="
          handleFileDownload({
            reportId: invoice.invoiceNumber,
            type: 'IN',
            invoiceType: invoice.invoiceType,
            fileName: `${invoice.invoiceNumber}.pdf`
          })
        "
        v-if="!reportIsDownloading(invoice.invoiceNumber) && showDownload"
      />
      <async-loader
        class="small _p0 _plxs"
        v-if="reportIsDownloading(invoice.invoiceNumber)"
      />
      <async-button
        v-if="$isInternalUser && invoice.block"
        class="--sm white"
        :executing="isUnBlocking"
        @clicked="unblock"
      >
        unblock
      </async-button>
      <async-button
        v-else-if="$isInternalUser"
        :executing="isBlocking"
        class="--sm white"
        @clicked="block"
      >
        block
      </async-button>
    </template>
    <template #collapsibleSection>
      <cloud-cannon-content
        class="bg-light-gray _pt0 _pbxs"
        :content="cloudCannonContent.header"
        :content-loading="cloudCannonContentLoading"
      />

      <div container>
        <div grid="row wrap">
          <div column="xs-12 s-4 m-4" class="_ptxs _pbxs">
            <label>Group</label>
            {{ invoice.groupName }} - {{ invoice.groupId }}
          </div>
          <div column="xs-12 s-4 m-4" class="_ptxs _pbxs">
            <label>Sub Group</label>
            {{ invoice.subGroupName }} - {{ invoice.subGroupId }}
          </div>
        </div>
        <div grid="row wrap">
          <div column="xs-12 s-4 m-2" class="_pbxs">
            <label>Invoice Amount</label>
            {{ toDollarFormat(invoice.invoiceAmount) }}
          </div>
          <div column="xs-12 s-4 m-2" class="_pbxs">
            <label>Paid Amount</label>
            {{ toDollarFormat(invoice.paidAmount) }}
          </div>
          <div column="xs-12 s-4 m-2" class="_pbxs">
            <label>Adjusted Amount</label>
            {{ toDollarFormat(invoice.adjustmentAmount) }}
          </div>
          <div column="xs-12 s-4 m-2" class="_pbxs">
            <label>Balance</label>
            {{ toDollarFormat(invoice.openAmount) }}
          </div>
          <div column="xs-12 s-4 m-2" class="_pbxs">
            <label>Invoice Type</label>
            {{ invoice.invoiceDescription }}
          </div>
          <div column="xs-12 s-4 m-2" class="_pbxs">
            <label>Invoice Status</label>
            {{ invoice.block ? 'BLOCKED' : invoice.paymentStatus }}
          </div>
          <div column="xs-12 s-4 m-2" class="_pbxs">
            <label>Invoice Date</label>
            {{ invoice.invoiceDate }}
          </div>
        </div>
      </div>

      <cloud-cannon-content
        class="bg-light-gray _pt0 _pbxs"
        :content="cloudCannonContent.footer"
        :content-loading="cloudCannonContentLoading"
      />
    </template>
  </collapsible-section>
</template>

<script>
import CollapsibleSection from '@sections/CollapsibleSection';
import DownloadButton from '@atoms/DownloadButton.vue';
import AsyncButton from '@molecules/AsyncButton';
import billing from '@mixins/billing';
import formattable from '@mixins/formattable';
import AsyncLoader from '@molecules/AsyncLoader';
import CloudCannonable from '@mixins/CloudCannonable';
import { useReporting } from '@composables/useReporting';
import { computed, onBeforeMount, ref } from '@vue/composition-api';
import { useStore, useRoute } from '@vue3shims';
export default {
  mixins: [billing, formattable, CloudCannonable],
  components: {
    AsyncLoader,
    CollapsibleSection,
    DownloadButton,
    AsyncButton
  },
  props: {
    invoice: {
      type: Object
    }
  },

  setup(props) {
    const store = useStore();
    const { reportIsDownloading, handleFileDownload } = useReporting();
    // const invoice = ref(props.invoice);
    const block = () => {
      store.dispatch('BLOCK_INVOICE', props.invoice);
    };
    const unblock = () => {
      store.dispatch('UNBLOCK_INVOICE', props.invoice);
    };
    const isBlocking = computed(() => {
      return store.getters.isBlocking;
    });
    const isUnBlocking = computed(() => {
      return store.getters.isUnBlocking;
    });
    const showDownload = computed(() => {
      return props.invoice.others != null && props.invoice.others.length > 0;
    });
    onBeforeMount(async () => {
      await store.dispatch('cloudCannon/GET_CLOUD_CANNON_CONTENT', {
        cloudCannonResource: '/invoice-details.json'
      });
    });
    return {
      block,
      unblock,
      // invoice,
      isBlocking,
      isUnBlocking,
      reportIsDownloading,
      handleFileDownload,
      showDownload
    };
  }
};
</script>
<style scoped>
.collapsible-section.collapsed .section-header {
  border-bottom: 1px solid #d8d8d8;
  border-top: 1px solid #d8d8d8;
}
</style>
